
























import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { ICustomer } from '@/lib/interfaces';
import { createCustomer, getCustomer, updateCustomer } from '@/services/api.service';

@Component({
  directives: {
    focus,
  },
})
export default class CustomerEditor extends Vue {
  private customer: ICustomer = {
    name: '',
  };

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    let customer: ICustomer;
    if (to.query.customer_id) {
      customer = await getCustomer(to.query.customer_id as string);
    }
    next((vm: CustomerEditor) => {
      if (customer) {
        vm.customer = customer;
      }
    });
  }

  private async editFinish() {
    const response = this.$route.query.customer_id
      ? await updateCustomer(this.customer)
      : await createCustomer(this.customer);
    this.$router.push({
      name: 'customers',
    });
  }
}
